/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practical_ExperienceInputs */

const en_practical_experience = /** @type {(inputs: Practical_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical experience`)
};

const de_practical_experience = /** @type {(inputs: Practical_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praxiserfahrung`)
};

/**
* | output |
* | --- |
* | "Practical experience" |
*
* @param {Practical_ExperienceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const practical_experience = /** @type {((inputs?: Practical_ExperienceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practical_ExperienceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_practical_experience(inputs)
	return en_practical_experience(inputs)
});